import React from 'react';
import PaymobLogo from './../../../../../statics/img/esaypaisa/paymob.png';
import Declined from './../../../../../statics/img/card/declined_payment.gif';

function DeclinedPayment() {
    return (
        <div className="payment_status_container declined">
            <span>Cancel</span>
            <img src={Declined} />
            <h3>Payment declined</h3>
            <p>Insufficient balance</p>
            <div className="content">
                <button>Try again</button>
            </div>
            <div className="footer">
                <span>Powered by</span>
                <img src={PaymobLogo} />
            </div>
        </div>
    )
}

export default DeclinedPayment;